export default "/_next/static/images/4d43c502c3b1a123c636b02dcc8fa44a.jpg";